var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppSymbolBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.56,
    height: 113.56,
    viewBox: "0 0 113.56 113.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.79,59.26c5.31,0,7.33-4.68,7.33-10.37v-8.65c0-5.69-2.01-10.38-7.33-10.38s-7.34,4.7-7.34,10.38v8.65c0,5.68,2.03,10.37,7.34,10.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.56,0H12C5.4,0,0,5.4,0,12V101.56c0,6.6,5.4,12,12,12H101.56c6.6,0,12-5.4,12-12V12c0-6.6-5.4-12-12-12ZM56.79,17.12c15.46,0,27.99,12.53,27.99,27.99s-12.53,27.99-27.99,27.99-27.99-12.53-27.99-27.99,12.53-27.99,27.99-27.99ZM28.43,94.45c7-15.66,25.37-22.68,41.03-15.67,6.98,3.12,12.56,8.7,15.67,15.67H28.43Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppSymbolBlack);
export default __webpack_public_path__ + "static/media/app_symbol_black.8f1472d01677d7663b7a1501d843e62a.svg";
export { ForwardRef as ReactComponent };